import { render } from "./PrivacyPolicy.vue?vue&type=template&id=7f16ce8a&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=7f16ce8a&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f16ce8a"]])

export default __exports__